import { useAppDispatch } from "../../../hooks/hooks";
import { useEffect, useState } from "react";
import Map from '../../../common/components/map'
import { messaging } from "../../../service/firebase";
import { onMessage } from "firebase/messaging";
import _ from "lodash";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const CustomerAgentTrack = () => {
	const dispatch = useAppDispatch()
	const [location, setLocation] = useState<any>([])
	const [payload, setPayload] = useState<any>([{ notification: { title: '', body: '' } }])
	const containerStyle = {
		width: '100%',
		height: '400px'
	};
	const center = {
		lat: 10.7905,
		lng: 78.7047
	};
	const image = require('../../../assets/img/delivery.png')
	console.log(location, 'location')
	useEffect(() => {
		new Promise((resolve) => onMessage(messaging, (payload: any) => {
			const latLongData = _.split(payload?.data?.Location, ',');
			console.log(latLongData, 'latLongDatapayload')
			setPayload({ notification: { title: '', body: payload?.data?.Location } })
			console.log(payload)
			setLocation(
				{
					Latitude: latLongData[0],
					Longitude: latLongData[1]
				}

			)
			resolve(payload)
		}))
	}, [])


	return (
		<>

			<div className="flex flex-col items-center ">

				<div className="h-full w-full  flex flex-col justify-between bg-gray-50 mb-8 py-5 border border-gray-200">
					<div className="w-full bg-white px-5 text-gray-800">

						<div className="w-full h-full">
							<LoadScript googleMapsApiKey="AIzaSyDOCJ7V-QaS9nnf7zZ1B7ZEgrkI-YcxWA0">
								<GoogleMap
									mapContainerStyle={containerStyle}
									center={center}
									zoom={10}
								>
									<Marker
										position={{ lat: Number(location.Latitude), lng: Number(location.Longitude) }}
										icon={image}

									/>
								</GoogleMap>
							</LoadScript>
						</div>
						<div>
							<h2>Notification Component</h2>
							<ul>

								<li><strong>Message: </strong>
									{payload?.notification?.body}
								</li>

							</ul>
						</div>
					</div>



				</div>
			</div>
		</>

	);
};

export default CustomerAgentTrack;
